export { FeaturesWithImage } from "./FeaturesWithImage";
export type { FeaturesWithImageProps, FeaturesWithImageHeadingLevel } from "./FeaturesWithImage";
